"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownListWrapperMultiCombobox = exports.DropdownListWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _popover = require("../../../../components/controls/popover/popover.tokens");
var _input = require("../../../../components/inputs/input/input.tokens");
var DropdownListWrapper = exports.DropdownListWrapper = _styledComponents.default.div.withConfig({
  displayName: "DropdownListWrapper",
  componentId: "sc-fp6p50-0"
})(["display:table-cell;background-color:white;", ";border-radius:", ";border:", ";width:", ";visibility:", ";"], _popover.tokens.shadow, _popover.tokens.border.radius, _popover.tokens.border.default, function (_ref) {
  var width = _ref.width;
  return width ? width : _input.tokens.size.width.fixed;
}, function (_ref2) {
  var hidden = _ref2.hidden;
  return hidden ? 'hidden' : 'visible';
});
var DropdownListWrapperMultiCombobox = exports.DropdownListWrapperMultiCombobox = _styledComponents.default.div.withConfig({
  displayName: "DropdownListWrapper__DropdownListWrapperMultiCombobox",
  componentId: "sc-fp6p50-1"
})(["position:absolute;top:100%;margin-top:2px;z-index:100000;display:table-cell;background-color:white;", ";border-radius:", ";border:", ";width:", ";visibility:", ";"], _popover.tokens.shadow, _popover.tokens.border.radius, _popover.tokens.border.default, function (_ref3) {
  var width = _ref3.width;
  return width ? width : _input.tokens.size.width.fixed;
}, function (_ref4) {
  var hidden = _ref4.hidden;
  return hidden ? 'hidden' : 'visible';
});